import { Avatar, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react';

import { TableFilter } from 'shared/ui/TableFilter';

import { IStatisticMessages } from '../service/messages.interface';
import { AnalyticsFiltersProps } from '../../AnalyticsFilters/service/filters.interface';

type Props = {
    readonly source: IStatisticMessages['message_members_statistic'];
    readonly filters: AnalyticsFiltersProps;
    readonly onFiltersUpdate: (update) => void;
    readonly loading: boolean;
};

export const MessagesTable: React.FC<Props> = ({
    filters,
    onFiltersUpdate,
    loading,
    source,
}) => {
    const [selectedRows, setSelectedRows] = useState<React.Key[]>(
        filters.telegram_accounts
    );

    const rowSelection = {
        selectedRows: selectedRows,
        preserveSelectedRowKeys: true,
        onChange: update => {
            setSelectedRows(update);
            onFiltersUpdate({
                telegram_accounts: update,
            });
        },
    };

    useEffect(() => {
        /**
         * Выбор  участников для отображения графика сообщений
         */
        if (source.length) {
            const accounts = source.map(u => u.telegram_id);
            onFiltersUpdate({
                telegram_accounts: accounts,
            });
            setSelectedRows(source.map(u => u.telegram_id));
        }
    }, [source]);

    return (
        <Table
            loading={loading}
            dataSource={source}
            rowKey={user => user.telegram_id}
            rowSelection={rowSelection}
        >
            <Table.Column
                title='Сообщения'
                render={user => <strong>{user.count_messages}</strong>}
            />
            <Table.Column
                title={
                    <TableFilter<string> title='Имя'>
                        <TableFilter.Text />
                    </TableFilter>
                }
                render={member => (
                    <Space>
                        {member.image && <Avatar src={member.image} />}
                        {!member.image && (
                            <Avatar>{member.name.charAt(0)}</Avatar>
                        )}
                        <span>{member.name}</span>
                    </Space>
                )}
            />
            <Table.Column
                title={
                    <TableFilter<string> title='Юзернейм'>
                        <TableFilter.Text />
                    </TableFilter>
                }
                dataIndex={'nick_name'}
            />
        </Table>
    );
};
